export default __webpack_public_path__ + "static/media/sounds/daze_passage_instructions.mp3";